export enum ENDPOINT {
  Authorize = '/v1/authorize',
  Cart = '/v1/cart',
  Checkout = '/v1/checkout',
  FindApproval = '/v1/lease-application/find',
  LeaseAppSubmit = '/v1/lease-application/submit',
  LeaseAppUpdate = '/v1/lease-application',
  CreditCard = '/v1/credit-card',
  Sign = '/v1/sign',
  VerifyOtp = '/v1/lease-application/find/verify',
  ResendOtp = '/v1/lease-application/find/resend',
  SignChangeCard = '/v1/change-card',
}
